export const initialState = {
  wealthboxIntegrationModalOpen: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_WEALTHBOX_INTEGRATION_MODAL":
      return {
        ...state,
        wealthboxIntegrationModalOpen: true,
      };
    case "CLOSE_WEALTHBOX_INTEGRATION_MODAL":
      return {
        ...state,
        wealthboxIntegrationModalOpen: false,
      };
    default:
      return state;
  }
};
export default reducer;
